import { Stat, StatLabel, StatNumber } from '@chakra-ui/react';

function StatCard({
  value,
  label,
  decimals = 2,
  suffix = '',
  fallback = '–',
}) {
  const hasValue = value !== null && value !== undefined;

  const formattedValue = hasValue
    ? `${Number(value).toFixed(decimals)}${suffix}`
    : fallback;

  return (
    <Stat
      flexGrow="0"
      px={2}
      py={1}
      border="1px solid"
      borderColor="gray.100"
      borderRadius="base"
      width="fit-content"
    >
      <StatNumber className="stat-value" fontSize="xl">
        {formattedValue}
      </StatNumber>

      <StatLabel
        color="gray.500"
        className="stat-label"
        width="fit-content"
        whiteSpace="nowrap"
        fontSize="xs"
      >
        {label}
      </StatLabel>
    </Stat>
  );
}

export default StatCard;
